//Gifs
const ListGif = `/images/settings/viewerSettings/ListViewer.gif`;
const ImmerseGif = `/images/settings/viewerSettings/ImmerseViewer.gif`;
const GalleryGif = `/images/settings/viewerSettings/GalleryViewer.gif`;

export enum viewerSettingsEnum {
 themeAndGating = "Theme & Gating",
 library = "Library",
 defaultViewer = "Default Viewer",
 emailContent = "Email Content",
}

export enum defaultViewersEnum {
    LIST_VIEWER = "LIST_VIEWER",
    IMMERSE_VIEWER ="IMMERSE_VIEWER",
    GALLERY_VIEWER = "GALLERY_VIEWER"
}


export enum themeAndGatingWidgetsEnum {
 passwordText = "passwordText",
 gatingText = "gatingText",
 ndaText = "ndaText",
 otpText = "otpText"
}

export const tabOrders = {
  [viewerSettingsEnum.themeAndGating]: 0,
  [viewerSettingsEnum.library]: 1,
  [viewerSettingsEnum.defaultViewer]: 2,
  [viewerSettingsEnum.emailContent]: 3,
}

export const listOfTabs = [
 {
    name: viewerSettingsEnum.themeAndGating,
  },
  {
    name: viewerSettingsEnum.library,
  },
  {
    name: viewerSettingsEnum.defaultViewer,
  },
  {
    name: viewerSettingsEnum.emailContent,
  }
];

export const themeAndGatingWidgetKeys = {
  passwordText: "passwordText",
  gatingText: "gatingText",
  ndaText: "ndaText",
  otpText: "otpText"
}

export const listOfDefaultViewers = [
     {
        'id': defaultViewersEnum.LIST_VIEWER,
        'title': 'List',
        "label": "List Viewer",
        'description': `Arrange your assets in a vertical scrolling list.`,
        'gif': ListGif,
         'imageOrder': 0
    },
    {
        'id': defaultViewersEnum.IMMERSE_VIEWER,
        'title': 'Immerse',
        "label": "Immerse Viewer",
        'description': `Arrange your assets in a horizontal scrolling list.`,
        'gif': ImmerseGif,
         'imageOrder': 1
    },
    {
        'id': defaultViewersEnum.GALLERY_VIEWER,
        'title': 'Gallery',
        "label": "Gallery Viewer",
        'description': `Arrange your assets in a horizontal scrolling list.`,
        'gif': GalleryGif,
        'imageOrder': 2
    }
]